import * as yup from "yup";
import BaseForm from "../../../../shared/components/form/BaseForm";
import FormInput from "../../../../shared/components/input/FormInput";
import FormSelect from "../../../../shared/components/select/FormSelect";

const CreateUserForm = ({ onSubmitHandler, roles }) => {
  const validationSchema = yup.object({
    username: yup.string().required("El nombre de usuario es obligatorio"),
    fullname: yup.string().required("El nombre completo es obligatorio"),
    email: yup.string().required("El correo electrónico es obligatorio"),
    role: yup.string().required("El rol de usuario es obligatorio"),
  });

  const defaultValues = {
    username: "",
    fullname: "",
    email: "",
    password: null,
    role: "",
  };

  return (
    <BaseForm
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      onSubmitHandler={onSubmitHandler}
    >
      <div className="flex flex-col justify-between gap-y-4">
        <FormInput name="username" label="Nombre de usuario" required />
        <FormInput name="fullname" label="Nombre completo" required />
        <FormInput name="email" label="Correo electrónico" required />
        <FormInput type="secret" name="password" label="Contraseña" />
        <FormSelect name="role" label="Rol" options={roles} required />
      </div>
    </BaseForm>
  );
};

export default CreateUserForm;
